// src/data/mindeaseModulesMetadata.js
// Card metadata for the modules grid — derived from the module files.
//
// The grid used to read a hand-maintained list cloned from Friendships Vibe,
// so the live cards said "Your Social Brain" and "Group Dynamics & Roles"
// over MindEase content, and claimed durations and XP the modules behind
// them never matched. Nothing here is typed twice: title, subtitle, level,
// category and artwork come from each module; duration and XP are summed
// from its parts.
import { mindeaseModules } from './modules/mindease-modules-index';
import { getMicroSessions, sessionMinutes } from '../utils/moduleShape';

const durationFor = (module) => {
  const minutes = getMicroSessions(module).reduce(
    (total, session) => total + sessionMinutes(session),
    0,
  );
  return minutes ? `${minutes} min` : module.duration || null;
};

// Everything a reader can earn: the completion bonus plus each part.
const xpFor = (module) => {
  const parts = getMicroSessions(module).reduce(
    (total, session) => total + (session.xp || 0),
    0,
  );
  return (module.xpReward || 0) + parts;
};

const imageFor = (module) => module.image || `/images/mindease-0${module.id}.jpg`;

export const mindeaseModulesData = mindeaseModules.map((module) => ({
  id: module.id,
  title: module.title,
  subtitle: module.subtitle,
  description: module.description,
  level: module.level || 'Foundation',
  category: module.category || 'Understanding',
  series: 'MindEase Vibe',
  coolFactor: module.coolFactor || null,
  image: imageFor(module),
  imageAlt: module.imageAlt || `${module.title} artwork`,
  difficulty: module.difficulty,
  duration: durationFor(module),
  xpReward: xpFor(module),
}));

export default mindeaseModulesData;
